import { QuizQueueDetails, QuizQueueIndexData } from '../../../types/queues';

// These are just random identifiers
export const QUES_QUEUE_ID = '7e74582c-37ec-4c51-8e59-c5796846c0ff';
export const FLASHCARD_QUEUE_ID = 'f18b7eab-bec9-4fc0-8112-d312f275fbd7';
export const SPACED_REP_QUEUE_ID = 'f0f26493-3dd9-4249-b44b-35923244bb6b';

/**
 *
 */
export const flattenQueues = (queueIndex?: QuizQueueDetails['index']) => {
  const memo: QuizQueueIndexData = {
    done: [],
    todo: [],
  };

  if (!queueIndex) return memo;
  Object.values(queueIndex).forEach((current) => {
    memo.todo.push(...current.todo);
    memo.done.push(...current.done);
  });
  return memo;
};
